var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/NodeCheckbox/NodeCheckbox.tsx";
import React from 'react';
import { Checkbox } from '@gmini/ui-kit/lib/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
export var NodeCheckbox = function NodeCheckbox(_ref) {
  var checked = _ref.checked,
      _onChange = _ref.onChange,
      disabled = _ref.disabled,
      indeterminate = _ref.indeterminate;
  return /*#__PURE__*/_jsx(Checkbox, {
    onChange: function onChange(e) {
      _onChange(e, e.target.checked);
    },
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    checked: checked,
    indeterminate: indeterminate,
    disabled: disabled
  });
};